module.exports = __webpack_public_path__ + "static/media/polyana.dedbd7e6.png";